import { Breadcrumb } from "antd";
import clsx from "clsx";
import { useNavigate } from "@shared/lib/react-router";
import "./breadcrumbs.scss";

type Route = {
  path: string;
  label: string;
};

interface BreadcrumbsProps {
  routes: Route[];
  disableFirst?: number;
}

export const Breadcrumbs = ({ routes, disableFirst = 0 }: BreadcrumbsProps) => {
  const navigate = useNavigate();

  const handleRouteClick = (path: string, index: number) => {
    if (index >= disableFirst) {
      navigate(path);
    }
  };

  return (
    <Breadcrumb separator=" / " className="breadcrumbs">
      {routes.map((route, index) => {
        const isDisabled = index < disableFirst;

        return (
          <Breadcrumb.Item key={route.path}>
            <span
              onClick={() => handleRouteClick(route.path, index)}
              className={clsx(
                "breadcrumbs__item",
                isDisabled && "breadcrumbs__item--disabled",
              )}
            >
              {route.label}
            </span>
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};
